<!-- eslint-disable max-len -->
<template>
  <div>
    <!--Messages d'erreur-->
    <div class="justify-content-center mx-auto col-12 error-messages-container">
      <Alert
        type="warning"
        message="Veuillez vérifier que tous les champs sont correctement remplis"
        :visible="validationError"
        @close="validationError = false" />

      <Alert
        type="danger"
        message="Nous ne parvenons pas à créer votre compte. Veuillez réessayer dans quelques instants."
        :visible="error"
        @close="error = false" />

      <Alert
        type="success"
        message="Votre compte a été créé avec succès"
        :visible="success"
        @close="success = false" />

      <Alert
        type="danger"
        message="Le nombre maximum d'utilisateurs pour cette licence est atteint"
        :visible="licenseErr"
        @close="licenseErr = false" />

      <Alert
        type="danger"
        :message="`Il existe déjà un compte pour l'identifiant ${name}, si vous êtes sûr d'avoir correctement saisi votre identifiant, vous pouvez recréer votre mot de passe depuis la page de connexion. Sinon veuillez saisir un autre identifiant.`"
        :visible="duplicate"
        @close="duplicate = false" />
    </div>
    <!--#Messages d'erreur-->

    <div class="row justify-content-center">
      <form @submit="formSubmit" class="col-12">
        <fieldset class="login-fields-container">
          <div class="form-group row">
            <label for="idInput" class="col-sm-12 col-md-6 col-form-label">Identifiant</label>
            <div class="col-sm-12 col-md-6">
              <input id="idInput"
                     type="text"
                     class="form-control"
                     v-model="name"
                     :class="{ 'is-invalid': formSubmitted && this.$v.name.$error }"
                     @input="onNameInput"
                     @focus="nameFlag = true"
                     @blur="nameFlag = false"
                     v-input-filter:id
                     autocomplete="off">
                          <div class="mt-2">
                <small class="text-dark">
                  <strong>L'identifiant doit contenir :</strong>
                  <ul class="mb-2 mt-1 pl-3">
                    <li :class="{
                      'text-success': this.$v.name.length,
                      'text-dark': !this.$v.name.length
                    }">
                      5 caractères minimum
                    </li>
                  </ul>
                </small>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label for="passwordInput" class="col-sm-12 col-md-6 col-form-label">
              Mot de passe
            </label>
            <div class="col-sm-12 col-md-6">
              <input id="passwordInput"
                     :type="passwordType"
                     class="form-control"
                     :class="{ 'is-invalid': formSubmitted && this.$v.password.$error }"
                     @input="onPasswordInput"
                     v-model="password"
                     @focus="passwordFlag = true"
                     @blur="passwordFlag = false"
                     v-input-filter:password
                     autocomplete="new-password">
              <div class="mt-2">
                <small class="text-dark">
                  <strong>Le mot de passe doit contenir :</strong>
                  <ul class="mb-2 mt-1 pl-3">
                    <li :class="{
                      'text-success': this.$v.password.length,
                      'text-dark': !this.$v.password.length
                    }">
                      8 caractères minimum
                    </li>
                    <li :class="{
                      'text-success': this.$v.password.number,
                      'text-dark': !this.$v.password.number
                    }">
                      1 chiffre
                    </li>
                    <li :class="{
                      'text-success': this.$v.password.upper,
                      'text-dark': !this.$v.password.upper
                    }">
                      1 majuscule
                    </li>
                    <li :class="{
                      'text-success': this.$v.password.special,
                      'text-dark': !this.$v.password.special
                    }">
                      1 caractère spécial parmi:<br>
                      <code class="bg-light text-dark px-2 py-1 rounded h6 special-chars-code">
                        {{ allowedSpecialChars }}
                      </code>
                    </li>
                  </ul>
                </small>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label for="passwordConfirmInput" class="col-sm-12 col-md-6 col-form-label">
              Confirmation mot de passe
            </label>
            <div class="col-sm-12 col-md-6">
              <input id="passwordConfirmInput"
                     :type="passwordType"
                     class="form-control"
                     :class="{ 'is-invalid': formSubmitted && this.$v.cPassword.$error }"
                     @input="onConfirmPasswordInput"
                     v-model="cPassword"
                     v-input-filter:password
                     autocomplete="new-password">
              <div v-if="formSubmitted && this.$v.cPassword.$error" class="mt-1">
                <div class="text-danger small" v-if="!this.$v.cPassword.sameAs">
                  Les mots de passe ne sont pas identiques
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <div class="form-check my-4 text-center">
          <input type="checkbox" class="form-check-input"
                 @click="switchVisibility" id="switchVisibility">
          <label class="form-check-label text-label" for="switchVisibility">
            Afficher les mots de passe
          </label>
        </div>

        <div class="row justify-content-center my-4">
          <div class="col-12 col-sm-8 mt-3">
            <button type="submit" class="btn btn-block btn-sm text-white fond-indigo">
              S'inscrire
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { required, sameAs } from 'vuelidate/lib/validators';
import { sanitizeInput, validateInput, ALLOWED_SPECIAL_CHARS } from '@/utils/validation';
import Alert from '../Alert.vue';

export default {
  data() {
    return {
      name: '',
      password: '',
      cPassword: '',
      passwordType: 'password',
      passwordFlag: false,
      nameFlag: false,
      formSubmitted: false,
      error: false,
      duplicate: false,
      licenseErr: false,
      success: false,
      validationError: false,
    };
  },
  components: {
    Alert,
  },
  computed: {
    allowedSpecialChars() {
      return ALLOWED_SPECIAL_CHARS;
    },
  },
  props: {
    email: String,
  },
  mounted() {
    this.name = '';
    this.password = '';
    this.cPassword = '';
  },
  methods: {
    switchVisibility() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    onNameInput() {
      this.name = sanitizeInput(this.name, 'id').replace(/\s/g, '');
      this.$v.name.$touch();
      if (this.formSubmitted) this.formSubmitted = false;
      this.validationError = false;
      this.error = false;
      this.duplicate = false;
      this.licenseErr = false;
    },
    onPasswordInput() {
      this.$v.password.$touch();
      if (this.formSubmitted) this.formSubmitted = false;
      this.validationError = false;
      this.error = false;
      this.duplicate = false;
      this.licenseErr = false;
    },
    onConfirmPasswordInput() {
      this.$v.cPassword.$touch();
      if (this.formSubmitted) this.formSubmitted = false;
      this.validationError = false;
      this.error = false;
      this.duplicate = false;
      this.licenseErr = false;
    },
    formSubmit(e) {
      e.preventDefault();
      this.formSubmitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.validationError = true;
        return;
      }

      const trimmedName = this.name.trim();
      const trimmedPassword = this.password.trim();
      const nameValidation = validateInput(trimmedName, 'id');
      const passwordValidation = validateInput(trimmedPassword, 'password');

      if (!nameValidation.isValid || !passwordValidation.isValid) {
        this.error = true;
        return;
      }

      const sanitizedData = {
        user: {
          username: sanitizeInput(trimmedName, 'id'),
          password: trimmedPassword,
        },
        token: this.$route.query.token,
      };

      axios.post('/auth/api/front/create', JSON.stringify(sanitizedData), { headers: { 'content-type': 'application/json' } })
        .then(() => {
          this.success = true;
          setTimeout(() => {
            window.location.href = `${window.location.origin}/auth?source=${encodeURI(this.$parent.source)}`;
          }, 2000);
        })
        .catch((err) => {
          if (err.response.data === 'Duplicated User') {
            this.duplicate = true;
          } else if (err.response.data === 'License already used') {
            this.licenseErr = true;
          } else {
            this.error = true;
          }
        });
    },
  },
  validations: {
    name: {
      required,
      length: (name) => name.length >= 5,
    },
    password: {
      length: (password) => password.length >= 8,
      required,
      number: (password) => /[0-9]/.test(password),
      upper: (password) => /[A-Z]/.test(password),
      special: (password) => /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(password),
    },
    cPassword: {
      sameAs: sameAs('password'),
      required,
    },
  },
};
</script>

<style scoped>
.login-fields-container {
  margin-left: 8px;
}

.special-chars-code {
  margin-top: 8px !important;
  display: inline-block;
}

.error-messages-container {
  margin-bottom: 25px !important;
}

/* Stylisation personnalisée de la checkbox "Afficher les mots de passe" */
.form-check {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0;
}

.form-check-input {
  width: 20px;
  height: 20px;
  cursor: pointer;
  border: 2px solid #ccc;
  border-radius: 4px;
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: white;
  transition: all 0.2s ease;
  margin: 0;
  flex-shrink: 0;
}

.form-check-input:checked {
  background-color: #482882;
  border-color: #482882;
}

.form-check-input:checked::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.form-check-input:hover {
  border-color: #482882;
}

.form-check-label {
  cursor: pointer;
  margin-left: 8px;
  margin-bottom: 0;
  padding-left: 0;
  user-select: none;
  line-height: 20px;
}
</style>
